const namedColors = [
  'transparent', 'aliceblue', 'antiquewhite', 'aqua', 'aquamarine', 'azure',
  'beige', 'bisque', 'black', 'blanchedalmond', 'blue', 'blueviolet', 'brown',
  'burlywood', 'cadetblue', 'chartreuse', 'chocolate', 'coral', 'cornflowerblue',
  'cornsilk', 'crimson', 'cyan', 'darkblue', 'darkcyan', 'darkgoldenrod',
  'darkgray', 'darkgreen', 'darkgrey', 'darkkhaki', 'darkmagenta',
  'darkolivegreen', 'darkorange', 'darkorchid', 'darkred', 'darksalmon',
  'darkseagreen', 'darkslateblue', 'darkslategray', 'darkslategrey',
  'darkturquoise', 'darkviolet', 'deeppink', 'deepskyblue', 'dimgray',
  'dimgrey', 'dodgerblue', 'firebrick', 'floralwhite', 'forestgreen', 'fuchsia',
  'gainsboro', 'ghostwhite', 'gold', 'goldenrod', 'gray', 'green',
  'greenyellow', 'grey', 'honeydew', 'hotpink', 'indianred', 'indigo', 'ivory',
  'khaki', 'lavender', 'lavenderblush', 'lawngreen', 'lemonchiffon', 'lightblue',
  'lightcoral', 'lightcyan', 'lightgoldenrodyellow', 'lightgray', 'lightgreen',
  'lightgrey', 'lightpink', 'lightsalmon', 'lightseagreen', 'lightskyblue',
  'lightslategray', 'lightslategrey', 'lightsteelblue', 'lightyellow', 'lime',
  'limegreen', 'linen', 'magenta', 'maroon', 'mediumaquamarine', 'mediumblue',
  'mediumorchid', 'mediumpurple', 'mediumseagreen', 'mediumslateblue',
  'mediumspringgreen', 'mediumturquoise', 'mediumvioletred', 'midnightblue',
  'mintcream', 'mistyrose', 'moccasin', 'navajowhite', 'navy', 'oldlace', 'olive',
  'olivedrab', 'orange', 'orangered', 'orchid', 'palegoldenrod', 'palegreen',
  'paleturquoise', 'palevioletred', 'papayawhip', 'peachpuff', 'peru', 'pink',
  'plum', 'powderblue', 'purple', 'rebeccapurple', 'red', 'rosybrown', 'royalblue',
  'saddlebrown', 'salmon', 'sandybrown', 'seagreen', 'seashell', 'sienna',
  'silver', 'skyblue', 'slateblue', 'slategray', 'slategrey', 'snow',
  'springgreen', 'steelblue', 'tan', 'teal', 'thistle', 'tomato', 'turquoise',
  'violet', 'wheat', 'white', 'whitesmoke', 'yellow', 'yellowgreen'
];

export const COLOR_TYPE = {
  type: 'string',
  anyOf: [
    { enum: namedColors },
    { pattern: '^#(?:[0-9a-fA-F]{3}){1,2}$' }
  ]
};

export const INTEGER_TYPE = {
  type: 'integer',
  minimum: -50,
  maximum: 50
}

export const INTEGER_TYPE_POSITIVE = { ...INTEGER_TYPE, minimum: 0 };

export const FONT_WEIGHT_TYPE = {
  anyOf: [
    {
      type: 'string',
      enum: [
        'normal', 'bold', 'lighter', 'bolder',
        'inherit', 'initial', 'revert', 'revert-layer', 'unset'
      ]
    },
    {
      type: 'integer',
      minimum: 1,
      maximum: 50
    }
  ]
};

export const DEFAULT_FONT_FAMILY = 'system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Open Sans, Helvetica Neue, sans-serif';

export const FONT_FAMILY_TYPE = {
  type: 'string',
  enum: [
    DEFAULT_FONT_FAMILY,
    'Arial, Helvetica, sans-serif',
    'Segoe UI, Tahoma, Geneva, sans-serif',
    'Helvetica Neue, Helvetica, Arial, sans-serif',
    'Roboto, Helvetica Neue, sans-serif',
    'Open Sans, sans-serif',
    'Courier New, Courier, monospace',
    'Lucida Console, Monaco, monospace',
    'Georgia, Times New Roman, Times, serif'
  ]
};
